export enum UserOrigin {
  DEFAULT = 'default',
  MANUAL = 'manual',
  AZURE_AD = 'azure-ad',
  GOOGLE_WORKSPACE = 'google-workspace',
}
